import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function query_log_record_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/log_app/query_log_record_list', params);
}

export async function query_log_subject_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/log_app/query_log_subject_list', params);
}

export async function query_subscribe_prefix_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/log_app/query_subscribe_prefix_list', params);
}

export async function subscribe_log_record_by_prefix(params: Record<string, any>) {
  return request.post('/log_app/subscribe_log_record_by_prefix', params);
}
export async function unsubscribe_log_record_by_prefix(params: Record<string, any>) {
  return request.post('/log_app/unsubscribe_log_record_by_prefix', params);
}
